var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2024_871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.304 3.3224L12.7152 0.7104C12.3752 0.3664 11.6104 0 11.0104 0H4C1.7944 0 0 1.7944 0 4V12C0 14.2056 1.7944 16 4 16H12C14.2056 16 16 14.2056 16 12V5.0128C16 4.3752 15.752 3.7736 15.304 3.3224ZM5.6 2.1C5.6 1.82386 5.82386 1.6 6.1 1.6H9.9C10.1761 1.6 10.4 1.82386 10.4 2.1V4.3C10.4 4.57614 10.1761 4.8 9.9 4.8H6.1C5.82386 4.8 5.6 4.57614 5.6 4.3V2.1ZM14.4 12C14.4 13.3232 13.3232 14.4 12 14.4H4C2.6768 14.4 1.6 13.3232 1.6 12V4C1.6 2.84697 2.41765 1.88103 3.50349 1.65166C3.77367 1.59459 4 1.82386 4 2.1V4.8C4 5.6824 4.7176 6.4 5.6 6.4H10.4C11.2824 6.4 12 5.6824 12 4.8V3.47675C12 3.03028 12.5407 2.80766 12.855 3.1247L14.1688 4.4496C14.3184 4.6 14.4 4.8 14.4 5.0128V12ZM8 8C6.6768 8 5.6 9.0768 5.6 10.4C5.6 11.7232 6.6768 12.8 8 12.8C9.3232 12.8 10.4 11.7232 10.4 10.4C10.4 9.0768 9.3232 8 8 8ZM8 11.2C7.5584 11.2 7.2 10.8408 7.2 10.4C7.2 9.9592 7.5584 9.6 8 9.6C8.4416 9.6 8.8 9.9592 8.8 10.4C8.8 10.8408 8.4416 11.2 8 11.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2024_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.00f4f198f200386be331e0cf5f294936.svg";
export { ForwardRef as ReactComponent };